import { useTranslation } from 'react-i18next'
import { AbandonWarningText } from './styled-components'

const AbandonReasonLabel = () => {
  const { t } = useTranslation()

  return (
    <>
      <AbandonWarningText>{t('subscriptionTable:abandon_why_warning')}</AbandonWarningText>
      {t('subscriptionTable:abandon_why_question')}
    </>
  )
}

export default AbandonReasonLabel
